<template>
  <div class="save" v-loading="loading">
    <div v-show="!formulateFlag">
      <div class="weekDate" @click="CalendarShow=true,triangle='triangle_down'">
        <div>{{ startWeek + '至' + endWeek }}</div><div :class="triangle"></div>
      </div>
      <van-calendar v-model="CalendarShow" type="range" first-day-of-week="1" :show-confirm="false" color="#029fd1" allow-same-day :default-date="defaultDate" :min-date="getMinDate()" @close="triangle='triangle_up',
      CalendarShow=false" @select="selectDate" />
      <!--膳食列表-->
      <div class="su-table-box">
        <div class="su-table">
          <!-- 表格标题 -->
          <div class="su-head">
            <div class="su-th" :style="{'width':viewWidth}"></div>
            <div class="su-th" v-for="(item,index) in MealTypeArray" :key="index" :style="{'width':viewWidth}">{{item.Name}}</div>
          </div>
          <div class="su-tr" v-for="(weekArray,i) in weekArrayList" :key="i">
            <div class="su-td" v-for="(item,index) in weekArray" :key="index" :style="{'width':viewWidth}" @click="openFormulate(index, item)">
              <div v-if="index===0">
                <div class="week">{{item.name}}</div>
              </div>
              <div v-else style="display: flex;flex-direction: column;">
                <div  v-for="(packageMeal,pi) in item.mealPackageName" :key="pi">{{packageMeal.Name}}</div>
                <div  v-for="(itemMeal,mi) in item.mealItemName" :key="mi">{{itemMeal.Name}}</div>
                <div style="color: #FF9162;font-size:20rpx;" v-if="item.hasFlag && item.Remark">{{item.Remark}}</div>
                <el-image v-if="!item.hasFlag" class="formulate_icon" :src="formulateImg"></el-image>
                <!-- <div v-if="!item.hasFlag">去制定</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-show="formulateFlag">
        <div class="weekDate">制定膳食计划</div>
        <div class="nowSelect">
          <van-icon name="warning-o" size="40rpx" color="#029fd1" />
          <div class="selectContent">当前选择：{{selectItem.nowDate}}/{{selectItem.weekName}}/{{selectItem.Name}}</div>
        </div>
        <el-form ref="ruleForm" class="form" :model="form" label-width="3rem" label-position="top">
            <el-form-item label="膳食套餐">
              <div class="contentPackage" @click="showPackagePicker=true" :style="{'color':selectPackage.Name ? '#000000':'#BBBBBB'}">
                <span v-if="!selectPackage.Name">请选择套餐</span>
                <div v-else class="itemWeek" @click.stop="cancelPack">{{selectPackage.Name}}<span style="margin-left:4px;">×</span></div></div>
              <div class="itemWeek" v-for="(item,index) in selectPackage.List" :key="index">
                {{item}}
              </div>
            </el-form-item>
            <el-form-item label="同步制定">
              <div class="contentPackage" @click="showCheckbox">
                <span v-if="weekResult.length<=0">请选择时间</span>
                <div class="itemWeek" v-for="(week,index) in weekResult" :key="index" @click.stop="deleteWeek(index)">{{week.name}}<span style="margin-left:4px;">×</span></div>
              </div>
            </el-form-item>
            <el-form-item label="同步房间">
              <el-cascader
              v-if="formulateFlag"
              style="width:100%;"
              @change="handleChange"
              :options="FloorArr"
              :props="props"
              collapse-tags
              clearable />
            </el-form-item>
            <el-form-item label="膳食">
              <div class="contentPackage" style="min-height: 125px;" @click="showlItembox">
                <span v-if="MealItems.length<=0">请选择膳食</span>
                <div class="itemWeek" v-for="(item,index) in MealItems" :key="index" @click.stop="onClickItem(item, false)">{{item.Name}}<span style="margin-left:4px;">×</span></div>
              </div>
            </el-form-item>
            <el-form-item label="备注">
              <!-- <textarea auto-height="true" class="contentPackage remarkTextarea" placeholder="请输入备注" model:value="{{Remark}}" placeholder-style="font-size: 32rpx;color: #BBBBBB;"></textarea> -->
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入备注"
                v-model="Remark">
              </el-input>
              <!-- <van-field
                v-model="Remark"
                rows="1"
                autosize
                type="textarea"
                placeholder="请输入备注"
              /> -->
              <div class="itemRemark" v-for="(item,index) in remarkArray" :key="index" @click="addRemark(item)">{{item}}</div>
            </el-form-item>
          </el-form>
          <div class="bottomBtn">
              <div class="submit" style="background: #E0E0E0;" @click="closeSave">取消</div>
              <div class="submit" style="background: #029FD1;margin-left:8px;" v-loading="loadingFlag" @click="onSubmit">保存</div>
          </div>
          <!-- 弹窗选择套餐 -->
          <van-popup round v-model="showPackagePicker" click-overlay="showPackagePicker=false" position="bottom">
            <van-picker show-toolbar :columns="Package" @cancel="showPackagePicker = false" @confirm="onConfirmPackage" value-key="Name"/>
          </van-popup>
          <!-- 弹框选择星期几 -->
          <van-popup round v-model="showWeekCheckbox" click-overlay="showWeekCheckbox=false" position="bottom">
            <div class="popupButton" >
              <div class="popupCancel" @click="showWeekCheckbox=false">取消</div>
              <div class="popupConfirm" @click="onConfirmCheckbox">确认</div>
            </div>
            <van-cell-group>
              <van-cell
                v-for="(item,index) in weekList"
                :key="index"
                :title="item.name"
                value-class="value-class"
                clickable
                @click="selectWeek(index)"
              >
                <van-icon v-if="item.check" color="#029fd1" name="success" size="24" />
              </van-cell>
            </van-cell-group>
          </van-popup>
          <!--弹框选择膳食-->
          <van-popup round v-model="showItembox" click-overlay="onCancelItembox" position="bottom">
            <div class="popupButton">
              <div class="popupCancel" @click="onCancelItembox">取消</div>
              <div class="popupConfirm" @click="showItembox=false">确认</div>
            </div>
            <div class="selectAll_checked"><van-checkbox v-model="checkedAll" shape="square" checked-color="#029fd1" @click="selectAll">全选</van-checkbox></div>
            <van-tree-select
              :items="ItemArray"
              :main-active-index.sync="mainActiveIndex"
              :active-id.sync="activeId"
              @click-nav="onClickNav"
              @click-item="onClickItem"
            />
          </van-popup>
      </div>
  </div>

</template>

<script>
import formulateImg from '@/assets/imgs/formulate.png'
import { intitime, formatDate } from '@/tool'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件

  // 组件状态值
  data () {
   return {
    formulateFlag: false,
    CalendarShow: false,
    formulateImg,
    activeName:'first',
    viewWidth: '20%',
    MealTypeArray: [],
    columnNum: 4,
    weekArray1: [{'week':1, 'name':'星期一'}],
    weekArray2: [{'week':2, 'name':'星期二'}],
    weekArray3: [{'week':3, 'name':'星期三'}],
    weekArray4: [{'week':4, 'name':'星期四'}],
    weekArray5: [{'week':5, 'name':'星期五'}],
    weekArray6: [{'week':6, 'name':'星期六'}],
    weekArray7: [{'week':7, 'name':'星期天'}],
    weekArrayList: [],
    startWeek: '',
    endWeek: '',
    defaultDate: [],
    triangle: 'triangle_up',
    selectItem: {},
    activeId: [],
    weekList: [
      {'id': 1,'name':'周一','check':false},
      {'id': 2,'name':'周二','check':false},
      {'id': 3,'name':'周三','check':false},
      {'id': 4,'name':'周四','check':false},
      {'id': 5,'name':'周五','check':false},
      {'id': 6,'name':'周六','check':false},
      {'id': 7,'name':'周天','check':false}
    ],
    ItemArray: [],
    Package: [],
    weekResult: [],
    selectPackage: {},
    Remark: '',
    loading:false,
    form:{},
    showPackagePicker: false,
    showWeekCheckbox: false,
    tentativeMealItems: [],
    tentativeActiveId: [],
    showItembox: false,
    MealItems: [],
    mainActiveIndex: 0,
    remarkArray: ['正常', '偏软', '食物糊点', '少盐少辣', '细切'],
    loadingFlag: false,
    checkedAll: false,
    // 全选的膳食分类的索引，用来判断全选是否要选中
    checkedAllArray: [],
    props: { multiple: true },
    rooms: [],
    FloorArr: []
   }
  },
  created(){
    this.startWeek = this.$route.query.startWeek // intitime(this.getFirstDayOfWeek(new Date()), 'yyyy-MM-dd'),
    this.endWeek =  this.$route.query.endWeek // intitime(this.getLastDayOfWeek(new Date()), 'yyyy-MM-dd')
    this.defaultDate = [this.getFirstDayOfWeek(new Date()), this.getLastDayOfWeek(new Date())]
    this.getMealType()
  },
  mounted () {
    var token = JSON.parse(localStorage.getItem('user'));
    this.userId = token.UserId
    this.searchData()
  },
  methods:{
    // tab切换
    handleClick(){

    },
    handleChange(value) {
        let rooms = []
        value.forEach(val=>{
          rooms.push(val[1])
        })
        this.rooms = rooms
      },
    // 取制定
    closeSave(){
      this.activeId = []
      this.formulateFlag = false
    },
    // 获取餐型
    getMealType(){
      this.loading = true
      this.$axios.get("/Pad/MealType").then((res) => {
        this.loading = false
        const data = res.data
        this.MealTypeArray = data.obj
        // 表格的列数
        this.columnNum = this.MealTypeArray.length + 1
        // 每列的宽度百分比
        this.viewWidth = 100/this.columnNum + '%'
        // 根据返回的餐型动态设置每列的宽度百分比viewWidth
        // 初始化周一到周天每天的计划列表，默认为空
        let weekArrayList = []
        for(let week = 1; week < 8; week++){
          let weekArray = this['weekArray'+week]
          // 获取周一到周天的日期
          let nowDate = intitime(this.getForDayOfWeek(new Date(this.startWeek.replace(/\-/g, '/')), week), 'yyyy-MM-dd')
          // 初始化周一到周天每一餐的数据(周几、日期，用于点击事件调用接口)
          for(let i = 0;i< this.MealTypeArray.length;i++){
            this.MealTypeArray[i].Week = weekArray[0].week
            this.MealTypeArray[i].weekName = weekArray[0].name
            this.MealTypeArray[i].nowDate = nowDate
            this.MealTypeArray[i].hasFlag = false
            // 进行深拷贝，不然Week最后都等于7
            let meal = JSON.parse(JSON.stringify(this.MealTypeArray[i]))
            weekArray[i+1] = meal
          }
          weekArrayList.push(weekArray)
          // this.setData({
          //   ['weekArray'+week] : weekArray
          // })
        }
        console.log('weekArrayList', weekArrayList)
        this.weekArrayList = weekArrayList
        this.QueryMealSheme(weekArrayList)
      }).catch((err) => {
          this.loading = false
          this.$message.error({
              message:'服务器异常，稍后再试',
              offset: 100
            });
        });
    },
    //获得周计划内容明细
    QueryMealSheme() {
      this.loading = true
      this.$axios.get('/Pad/ResidentElderlyWeek?profileId='+this.$route.query.Id+'&startWeek='+this.startWeek+'&endWeek='+this.endWeek)
        .then((res) => {
          const data = res.data
          this.loading = false
          if (data.ok) {
            let weekArrayList = this.weekArrayList
            data.obj.forEach(val => {
              for(let i = 0;i<weekArrayList.length;i++){
                // let weekArray = weekArrayList[i]
                for(let w = 1;w<weekArrayList[i].length;w++){
                  // 根据餐型和星期几找到对应的格子赋值
                  if(val.Week === weekArrayList[i][w].Week){
                    for(let v = 0;v<val.Data.length;v++){
                      if (val.Data[v].Applicablemeal === weekArrayList[i][w].Id) {
                        weekArrayList[i][w].mealId = val.Data[v].Id
                        weekArrayList[i][w].Remark = val.Data[v].Remark
                        weekArrayList[i][w].Mealitemid = val.Data[v].Mealitemid
                        weekArrayList[i][w].Mealpackageid = val.Data[v].Mealpackageid
                        weekArrayList[i][w].mealItemName = val.Data[v].mealItemName
                        weekArrayList[i][w].mealPackageName = val.Data[v].mealPackageName
                        if(val.Data[v].mealItemName.length > 0 || val.Data[v].mealPackageName.length > 0){
                          weekArrayList[i][w].hasFlag = true
                        }
                        break
                      }
                    }
                  }
                }
                if(val.Week === weekArrayList[i].Week) {
                  break
                }
              }
            })
            // console.log('膳食计划列表', weekArrayList)
            this.weekArrayList = weekArrayList
            this.$forceUpdate()
          } else {
            this.$message.error({
              message:data.msg,
              offset: 100
            });
          }
        })
        .catch((err) => {
          this.loading = false
          this.$message.error({
              message:'服务器异常，稍后再试',
              offset: 100
            });
        });
    },
    // 组装膳食数据
    arrGroup(arr, fn) {
        const obj = {};
        let MealItems = []
        arr.forEach(item => {
            const key = JSON.stringify(fn(item));
            obj[key] = obj[key] || [];
            item.id = item.Id
            item.text = item.Name
            obj[key].push(item)
            // 根据膳食ID匹配，获取膳食对象，用来在修改的时候显示
            this.activeId.forEach(itemId=>{
              if (itemId === item.Id) {
                MealItems.push(item)
              }
            })
        });
        // console.log('选择的膳食列表', MealItems)
        this.MealItems = MealItems
        return Object.keys(obj).map(k => {
            return obj[k];
        })
    },
    // 打开膳食制定界面
    openFormulate (index, item){
      if(index === 0){
        return
      }
      console.log('item', item)
      // 判断当前时间是否距离要修改的日期的0点相差大于12个小时，大于12个小时才能修改
      // let date2 = new Date(item.nowDate.replace(/\-/g, '/'));
      // date2.setHours(0, 0, 0, 0);
      // let timeDiff = date2.getTime() - new Date().getTime();
      // let hourDiff = Math.floor(timeDiff / (1000 * 60 * 60));
      // if (hourDiff < 12) {
      //   this.$message({
      //     message: "已超出修改时限！",
      //     offset: 100
      //   })
      //   return
      // }

      this.$axios.get('/Pad/MealPlanPackageItem?applicablemealId=' + item.Id + '&dt=' + item.nowDate).then((res) => {
          const data = res.data
          this.formulateFlag = true
          // 套餐
          let Package = data.obj.Package
          // 默认选中膳食
          this.activeId = []
          if(item.Mealitemid){
            this.activeId = item.Mealitemid.split(',')
          }
          //膳食,通过FoodClassification去分类
          const newArray = this.arrGroup(data.obj.Items, (item) => item.FoodClassification)
          let ItemArray = []
          let otherItem = {}
          newArray.forEach(val=>{
            if (val[0].FoodClassification) {
              let item = {}
              item.text = val[0].FoodClassification
              item.children = val
              ItemArray.push(item)
            } else {
              otherItem.text = '其他'
              otherItem.children = val
            }
          })
          // 其他放在最后
          if(otherItem.text){
            ItemArray.push(otherItem)
          }
          // 默认选中星期几
          let weekResult = []
          this.weekList.forEach(val =>{
            if (item.Week === val.id) {
              weekResult.push(val)
            }
          })
          // 默认显示备注
          let Remark = ''
          if (item.Remark) {
            Remark = item.Remark
          }
          // console.log('可选的膳食分类列表', ItemArray)
          this.selectItem = item
          this.ItemArray = ItemArray
          this.Package = Package
          this.formulateFlag = true
          this.weekResult = weekResult
          this.selectPackage = {}
          this.rooms = []
          this.Remark = Remark
          // 默认选中已选择的套餐
          Package.forEach(val =>{
            if(item.Mealpackageid === val.Id){
              this.selectPackage = val
            }
          })
          this.checkedAll = false
          this.checkedAllArray = []
      })

    },
    // 打开选择星期的弹框
    showCheckbox(){
      let weekList = this.weekList
      let weekResult = this.weekResult
      // 选择要同步的星期时设置前面勾选的星期为check=true
      for(let i = 0;i<weekList.length;i++){
        let hasFlag = false
        for(let w = 0; w<weekResult.length; w++) {
          if(weekResult[w].id === weekList[i].id){
            weekList[i].check = true
            hasFlag = true
          }
        }
        if(!hasFlag){
          weekList[i].check = false
        }
      }
      this.weekResult = weekResult
      this.weekList = weekList
      this.showWeekCheckbox = true
    },
    // 删除周几
    deleteWeek(index){
      this.weekResult.splice(index, 1)
    },
    // 打开选择膳食的弹框
    showlItembox(){
      this.tentativeActiveId = JSON.parse(JSON.stringify(this.activeId))
      this.tentativeMealItems = JSON.parse(JSON.stringify(this.MealItems))
      this.showItembox = true
    },
    // 关闭选择膳食的弹框
    onCancelItembox(){
      this.MealItems = this.tentativeMealItems
      this.activeId = this.tentativeActiveId
      this.showItembox = false
    },
    // 选择日期
    selectDate(event){
      console.log('event', event)
      let date = new Date(event[0])
      this.CalendarShow = false
      this.triangle = 'triangle_up'
      this.startWeek = intitime(this.getFirstDayOfWeek(date), 'yyyy-MM-dd')
      this.endWeek = intitime(this.getLastDayOfWeek(date), 'yyyy-MM-dd')
      this.defaultDate = [this.getFirstDayOfWeek(date), this.getLastDayOfWeek(date)]
      this.getMealType()
    },
    // 取消膳食套餐
    cancelPack(){
      this.selectPackage = {}
    },
    // 选择膳食套餐
    onConfirmPackage(event) {
      this.selectPackage = event
      this.showPackagePicker = false
    },
    // 选择星期
    selectWeek(index){
      let weekList = this.weekList
      weekList[index].check = !weekList[index].check
      this.weekList = weekList
    },
    // 确认选择星期几，只有点确认才去更新weekResult的值
    onConfirmCheckbox(){
      let weekList = this.weekList
      let weekResult = []
      for(let i = 0;i<weekList.length;i++){
        if(weekList[i].check){
          weekResult.push(weekList[i])
        }
      }
      this.weekResult = weekResult
      this.showWeekCheckbox = false
    },
    //选择膳食类别
    onClickNav(index){
      console.log('index', index)
      this.mainActiveIndex = index
      if (this.checkedAllArray.indexOf(this.mainActiveIndex) !== -1) {
        this.checkedAll = true
      }else{
        this.checkedAll = false
      }
    },
    // 全选某一类膳食
    selectAll(){
      if (this.ItemArray.length === 0) {
        return
      }
      if (this.checkedAll) {
        this.checkedAllArray.push(this.mainActiveIndex)
        this.ItemArray[this.mainActiveIndex].children.forEach(val =>{
            this.onClickItem(val, true)
          })
      }else{
        this.checkedAllArray = this.checkedAllArray.filter(item => item != this.mainActiveIndex)
        this.ItemArray[this.mainActiveIndex].children.forEach(val =>{
            this.onClickItem(val, false)
          })
      }
      console.log('index', this.checkedAllArray)

    },
    //选择膳食
    onClickItem(event, isCancel){
      console.log('event', event)
      // 判断对象数组中是否存在该对象
      let obj = event
      let MealItems = this.MealItems
      let index = MealItems.findIndex((item) => item.id === obj.id);
      // 如果有就去除，没有就添加
      if (index !== -1) {
        // isCancel用来判断已经选中的要不要取消，全选的时候已经选中的不用取消
        if (!isCancel) {
          MealItems.splice(index, 1);
          // 当某一类膳食全选后，点击取消选中某一个膳食时，取消全选状态
          this.checkedAll = false
          this.checkedAllArray = this.checkedAllArray.filter(item => item != this.mainActiveIndex)
        }
      } else {
        MealItems.push(obj);
        this.determineIsSelectAll()
      }
      // console.log('MealItems', MealItems)
      // 用来绑定组件选中值及提交的膳食ID数组
      let activeId = []
      MealItems.forEach(val=>{
        activeId.push(val.id)
      })
      this.MealItems = MealItems
      this.activeId = activeId
    },
    // 判断某一类膳食是否全选
    determineIsSelectAll(){
      let selectALlFlag = true
      this.ItemArray[this.mainActiveIndex].children.forEach(val =>{
        if(this.MealItems.findIndex(obj => obj.id === val.id) === -1){
          selectALlFlag = false
        }
      })
      if(selectALlFlag){
        this.checkedAll = true
        this.checkedAllArray.push(this.mainActiveIndex)
      }
    },
    // 添加备注
    addRemark(item){
      let Remark = this.Remark
      if(Remark.length > 0){
        Remark = Remark + ',' + item
      } else {
        Remark = item
      }
      this.Remark = Remark
    },
    getMinDate(){
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 30 * 5);
      return date
    },
    //获取当前日期周一
    getFirstDayOfWeek(date){
      var day =date.getDay() || 7;
      return new Date(date.getFullYear(),date.getMonth(),date.getDate()+1-day);
    },
    //获取当前日期周天
    getLastDayOfWeek (date) {
      var day = date.getDay() || 7;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()+7 - day);
    },
    //获取当前日期周几
    getForDayOfWeek (date, n) {
      var day = date.getDay() || 7;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()+n - day);
    },
    // 根据时间戳获取每月一号
    getCurrentMonthFirst(timeStamp){
      var date = new Date(timeStamp);
      date.setDate(1);
      return date;
    },
    // 根据时间戳获取每月的最后一天
    getCurrentMonthLast(timeStamp) {
      let date = new Date(timeStamp);
      let currentMonth = date.getMonth();
      let nextMonth = ++ currentMonth;
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth,1);
      let oneDay = 1000*60*60*24;
      return new Date(nextMonthFirstDay - oneDay);
    },
    //获取所有长者信息
    // getAssessingElderly(type) {
    //     this.$axios.post("/Evaluate/AssessingElderly").then((res) => {
    //         const data =res.data
    //         this.assessingElderly = data.obj;
    //     })
    // },
    // 查询房间信息
    searchData() {
      this.$axios.post('/Pad/FilterQuery?userId=' + this.userId).then((response) => {
        if (response.data.ok) {
              const filtrate = response.data.obj;
              const buildingAreas = filtrate.BuildingAreas;
              let FloorArr = []
              buildingAreas.forEach(val =>{
                val.Floors.forEach(F =>{
                  let floor = {}
                  floor.label = F.Name
                  floor.value = F.Name
                  floor.children = []
                  F.Rooms.forEach(r =>{
                     floor.children.push({
                      label: r,
                      value: r
                     })
                  })
                  FloorArr.push(floor)
                })
              })
              this.FloorArr = FloorArr
            } else {
                this.$message.error({
                  message: response.msg,
                  offset: 100
                });
            }
        }), err => {
            return false;
        };
    },
    //提交评估
    onSubmit() {
      let weekArray = []
      this.weekResult.forEach(val=>{
        weekArray.push(val.id)
      })
      this.loadingFlag = true
      // Applicablemeal="+this.selectItem.Id+"&DT="+this.selectItem.nowDate+"&Id=2f4fe903-44d7-40b3-b680-e831160c879a"+this.selectItem.mealId+"&MealItems="+this.activeId.join(',')+"&MealPackageId="+this.selectPackage.Id+"&ProfileId="+this.$route.query.Id+"&Remark="+this.Remark+"&Week="+weekArray
      this.$axios.post("/Pad/MealPlanEdit",{
        Applicablemeal:this.selectItem.Id,
        DT:this.selectItem.nowDate,
        Id:this.selectItem.mealId,
        MealItems:this.activeId.join(','),
        MealPackageId:this.selectPackage.Id,
        ProfileId:this.$route.query.Id,
        Remark:this.Remark,
        Week:weekArray,
        Rooms: this.rooms
      }).then((res) => {
            this.loadingFlag = false
            this.$message.success({
              message:'定制成功',
              offset: 100
            });
            this.closeSave()
            this.getMealType()
        }).catch((err) => {
            this.loadingFlag = false
        });
    },
  }

}
</script>

<style scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.save  {
  height: 100%;
}
.form >>> .el-form-item__label  {
  padding: 0;
}
.form >>> .el-form-item  {
  margin-bottom: 10px;
}
.form {
  padding:0 16px 90px 16px;
  background-color: #FFFFFF;
}

.submit {
  width: 148px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  margin: 20px auto;
  border-radius: 24px;
  font-size: 16px;
  color: #fff;
  display: inline-block;
}

.su-table-box {
  padding-bottom: 20px;
  width: 100%;
  margin: 0rpx auto;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.su-table {
  border-collapse: collapse;
  background-color: #FFFFFF;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
}

.su-tr {
  width: 100%;
  height: auto;
  border-bottom: solid 1px #ECEEF0;
  display: flex;
  border-collapse: collapse;
  border-spacing: 0;
}

.su-head {
  width: 100%;
  font-size: 14px;
  color: #333333;
  background: #7ecee8;
  height: 30px;
  font-weight: 400;
  border-bottom: solid 1px #ECEEF0;
  display: flex;
  border-collapse: collapse;
  border-spacing: 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.su-th {
  word-wrap: break-word;
  border-right: solid 1px #ECEEF0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 14px;
}

.su-td {
  height: auto;
  min-height: 56px;
  text-align: center;
  word-wrap: break-word;
  border-right: solid 1px #ECEEF0;
  font-weight: 400;
  color: #7C7C7C;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 14px;
}
.su-tr:last-child {
  border-bottom: none;
}
.su-th:last-child {
  border-right: none;
}
.su-td:last-child {
  border-right: none;
}
.formulate_icon{
  width: 24px;
  height: 24px;
}
.triangle_up{
  width: 0px;
  height: 0px;
  border: 8px solid transparent;
  border-top-color: #000000;
  position: relative;
  top: 5px;
  margin-left: 3px;
}

.triangle_down{
  width: 0px;
  height: 0px;
  border: 8px solid transparent;
  border-bottom-color: #000000;
  position: relative;
  top: -3px;
  margin-left: 3px;
  transform: rotate(360deg);
}
.week{
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.weekDate{
  padding: 0px 14px 12px 14px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  display: flex;
}
.nowSelect{
  height: 44px;
  background: #adddee;
  border-radius: 8px;
  margin: 0 12px 12px 12px;
  font-weight: 400;
  color: #029fd1;
  font-size: 14px;
  padding: 0 13px;
  display: flex;
  align-items: center;
}
.selectContent{
  margin-left: 7px;
  height: 20px;
  line-height: 20px;
}
.contentPackage{
  background: rgba(242,244,246,0.5);
  border-radius: 8px 8px 8px 8px;
  height: auto;
  min-height: 38px;
  line-height: 38px;
  padding: 0 8px;
  margin: 0 auto;
  font-size: 16px;
  color: #BBBBBB;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.itemWeek{
  height: 24px;
  line-height: 24px;
  font-weight: 400;
  color: #029fd1;
  font-size: 14px;
  padding: 2px 5px;
  margin: 8px 8px 8px 0;
  background: #d1eef7;
  border-radius: 4px 4px 4px 4px;
  display: inline-block;
  position: relative;
  z-index: 9;
}
.popupButton{
  display: flex;
  height: 48px;
  justify-content: space-between;
  line-height: 48px;
  border-bottom: solid 1px #f2f2f2;
}

.popupCancel{
  color:#333333;
  padding:0 16px;
  font-size: 16px;
  font-weight: 500;
}

.popupConfirm{
  color:#029fd1;
  padding:0 16px;
  font-size: 16px;
  font-weight: 500;
}
.van-sidebar-item--select::before{
  background-color:#029fd1;
}
.van-sidebar-item--select, .van-sidebar-item--select:active{
  background-color:#FFFFFF;
  color:#029fd1;
}
.van-tree-select__item--active{
  color: #029fd1;
}
.itemRemark{
  display: inline-block;
  height: 24px;
  line-height: 24px;
  font-weight: 400;
  color: #7D7F83;
  font-size: 14px;
  padding: 2px 5px;
  margin-right: 8px;
  margin-top: 8px;
  background: rgba(225,225,225,0.5);
  border-radius: 4px 4px 4px 4px;
}
.bottomBtn{
  display: flex;
  justify-content: center;
  background-color: #FFFFFF;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 90px;
  z-index: 9;
}
.van-tree-select__content{
  padding-top: 40px;
}
.selectAll_checked{
  display: flex;justify-content: flex-end;padding: 15px 20px 0px 0px;position: absolute;right: 0px;z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/mealsPlan/plan.vue